// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2ySI2","validationTips":"StatementDescriptor_validationTips__3U7ez"};